import { adminActionButtonSx } from 'src/theme/adminActionButton';
// import { useFormik } from 'formik';
// import * as Yup from 'yup';
// import { TextField, Button, Stack, Typography } from '@mui/material';
// import { toast } from 'react-toastify';
// import { LoadingButton } from '@mui/lab';
// import { verifyOtp } from 'src/helper/backend_helper';

// export default function StepEnterOtp({ email, onNext }) {
//   const formik = useFormik({
//     initialValues: { otp: '' },
//     validationSchema: Yup.object({
//       otp: Yup.string().required('OTP is required')
//     }),
//     onSubmit: async (values) => {
//       try {
//         console.log(values);
//         await verifyOtp({ ...values, email }, {});

//         // TODO: validate OTP via backend
//         toast.success('OTP verified');
//         onNext(values.otp);
//       } catch (err) {
//         toast.error('Invalid OTP');
//       }
//     }
//   });

//   return (
//     <form onSubmit={formik.handleSubmit}>
//       <Stack spacing={2}>
//         <Typography variant="h6">Enter OTP sent to {email}</Typography>
//         <TextField
//           label="OTP"
//           name="otp"
//           fullWidth
//           value={formik.values.otp}
//           onChange={formik.handleChange}
//           error={formik.touched.otp && Boolean(formik.errors.otp)}
//           helperText={formik.touched.otp && formik.errors.otp}
//         />

//         <LoadingButton
//           fullWidth
//           size="medium"
//           type="submit"
//           variant="contained"
//           //   onClick={() => handleLogin}
//           loading={formik.isSubmitting}
//           sx={{
//             backgroundColor: '#000000',
//             color: '#E8BF21',
//             '&:hover': {
//               backgroundColor: '#000000',
//               color: '#E8BF21'
//             }
//           }}
//         >
//           Verify OTP
//         </LoadingButton>
//       </Stack>
//     </form>
//   );
// }

import { useRef } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { TextField, Button, Stack, Typography, Box } from '@mui/material';
import { toast } from 'react-toastify';
import { LoadingButton } from '@mui/lab';
import { verifyOtp } from 'src/helper/backend_helper';
import {
  ADMIN_REALM_AUTH_MODE,
  LEGACY_ADMIN_AUTH_MODE
} from 'src/auth/adminRealmAuth';

export default function StepEnterOtp({ email, authMode, onNext }) {
  const otpLength = 6;
  const inputRefs = useRef([]);

  const formik = useFormik({
    initialValues: { otp: '' },
    validationSchema: Yup.object({
      otp: Yup.string()
        .length(otpLength, `OTP must be ${otpLength} digits`)
        .required('OTP is required')
    }),
    onSubmit: async (values) => {
      try {
        // Realm recovery validates and atomically consumes the OTP during the
        // final reset. Never send a realm-scoped artifact to the legacy
        // verifier, which has no explicit realm input.
        if (authMode === LEGACY_ADMIN_AUTH_MODE) {
          await verifyOtp({ ...values, email }, {});
        } else if (authMode !== ADMIN_REALM_AUTH_MODE) {
          throw new Error('Password recovery mode is unavailable.');
        }
        // toast.success('OTP verified');
        onNext(values.otp);
      } catch (err) {
        toast.error('Invalid OTP');
      }
    }
  });

  const handleOtpChange = (e, index) => {
    const { value } = e.target;
    if (/^\d?$/.test(value)) {
      const otpArray = formik.values.otp.split('');
      otpArray[index] = value;
      const newOtp = otpArray.join('').padEnd(otpLength, '');
      formik.setFieldValue('otp', newOtp);

      // Auto focus next
      if (value && index < otpLength - 1) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !formik.values.otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handleOtpPaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData('text').trim();
    if (!/^\d{6}$/.test(pasteData)) return;

    const otpArray = pasteData.split('');
    formik.setFieldValue('otp', pasteData);

    // Fill inputs and focus the last one
    otpArray.forEach((digit, i) => {
      inputRefs.current[i].value = digit;
    });
    inputRefs.current[otpArray.length - 1]?.focus();
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <Stack spacing={2} alignItems="center">
        <Typography variant="h6">Enter OTP sent to {email}</Typography>

        <Box display="flex" gap={1}>
          {Array.from({ length: otpLength }).map((_, i) => (
            <TextField
              key={i}
              inputRef={(el) => (inputRefs.current[i] = el)}
              value={formik.values.otp[i] || ''}
              onChange={(e) => handleOtpChange(e, i)}
              onKeyDown={(e) => handleKeyDown(e, i)}
              onPaste={(e) => handleOtpPaste(e)}
              inputProps={{ maxLength: 1, style: { textAlign: 'center' } }}
              sx={{ width: 50 }}
              error={formik.touched.otp && Boolean(formik.errors.otp)}
            />
          ))}
        </Box>

        {formik.touched.otp && formik.errors.otp && (
          <Typography color="error">{formik.errors.otp}</Typography>
        )}

        <LoadingButton
          fullWidth
          size="medium"
          type="submit"
          variant="contained"
          loading={formik.isSubmitting}
          sx={{
            ...adminActionButtonSx
          }}
        >
          Verify OTP
        </LoadingButton>
      </Stack>
    </form>
  );
}
